import {
  EyeIcon,
  PencilSquareIcon,
  TrashIcon,
} from '@heroicons/react/24/outline';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router';

function GridCardItem({
  name,
  description = '',
  status = null,
  editLink = null,
  showLink = null,
  imageUrl = null,
  onDelete = null,
}) {
  return (
    <li className="col-span-1 divide-y divide-black/10 rounded-lg bg-white/80 shadow-sm">
      <div className="flex w-full items-center justify-between space-x-6 p-6">
        <div className="flex-1 truncate">
          <div className="flex items-center space-x-3">
            <h3 className="truncate font-medium text-black text-sm">{name}</h3>
            {status && (
              <span
                className={`inline-flex shrink-0 items-center rounded-full px-1.5 py-0.5 font-medium text-xs ring-1 ring-inset ${
                  status.toLocaleLowerCase() === 'active'
                    ? 'bg-rcprimary-400 text-black ring-rcprimary-600'
                    : 'bg-red-50 text-red-700 ring-red-600/20'
                }`}
              >
                {status}
              </span>
            )}
          </div>
          <p className="mt-1 truncate text-black/70 text-sm">
            {description}&nbsp;
          </p>
        </div>
        {imageUrl && (
          <img
            className="h-10 w-10 shrink-0 bg-rcgray-300"
            src={imageUrl}
            alt={name}
          />
        )}
      </div>
      <div>
        <div className="-mt-px flex divide-x divide-black/10">
          {editLink && (
            <div className="flex w-0 flex-1">
              <NavLink
                to={editLink}
                className="relative -mr-px inline-flex w-0 flex-1 items-center justify-center gap-x-2 rounded-bl-lg border border-transparent py-4 font-semibold text-rcprimary-400 text-sm hover:text-rcprimary-400"
              >
                <PencilSquareIcon className="h-5 w-5" aria-hidden="true" />
                Edit
              </NavLink>
            </div>
          )}

          {showLink && (
            <div className="-ml-px flex w-0 flex-1">
              <NavLink
                to={showLink}
                className="relative inline-flex w-0 flex-1 items-center justify-center gap-x-2 rounded-br-lg border border-transparent py-4 font-semibold text-rcgray-900 text-sm"
              >
                <EyeIcon
                  className="h-5 w-5 text-rcgray-400"
                  aria-hidden="true"
                />
                View
              </NavLink>
            </div>
          )}

          {onDelete && (
            <div className="-ml-px flex w-0 flex-1">
              <button
                type="button"
                onClick={onDelete}
                className="relative inline-flex w-0 flex-1 items-center justify-center gap-x-2 rounded-br-lg border border-transparent py-4 font-semibold text-red-600 text-sm hover:text-red-800"
              >
                <TrashIcon className="h-5 w-5" aria-hidden="true" />
                Delete
              </button>
            </div>
          )}
        </div>
      </div>
    </li>
  );
}

GridCardItem.propTypes = {
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
  status: PropTypes.string,
  editLink: PropTypes.string,
  showLink: PropTypes.string,
  imageUrl: PropTypes.string,
  onDelete: PropTypes.func,
};

export default GridCardItem;
